import React from 'react';
import { QuestionnaireItemValidator } from '../../modules/unsw-fhir-questionnaire/Utilities/Validators';
import { IQuestionnaireItemTableComponent } from '../../modules/unsw-fhir/Questionnaire';
import {
  getPromptTexts,
  getSupportingLinkUris,
} from '../../modules/unsw-fhir/Questionnaire/extensions';
import { generateSimpleEnableWhenPredicate } from '../../modules/unsw-fhir/QuestionnaireResponse/helpers';
import { useModal } from '../../modules/unsw-modals';
import { Conditionals } from '../Fields/Conditional';
import TableField from '../Fields/TableField';
import { createOptionList } from './Choice';

const TableQuestionnaireItem = (props: IQuestionnaireItemTableComponent) => {
  const { enableWhen, ...rest } = props;
  const prompts = getPromptTexts(props);
  const supportLinks = getSupportingLinkUris(props);
  const { openSupportingLinks } = useModal();
  const options = createOptionList(props.option);
  return enableWhen ? (
    <Conditionals
      question={props.linkId}
      enableWhens={enableWhen.map(ew => ({
        when: ew.question,
        is: generateSimpleEnableWhenPredicate(ew),
      }))}>
      {({ enabled }) => (
        <TableField
          informationText={prompts}
          name={props.linkId}
          supportingLink={
            supportLinks.length !== 0
              ? () => openSupportingLinks(supportLinks)
              : undefined
          }
          validate={QuestionnaireItemValidator(props)}
          enabled={enabled}
          {...rest}
          options={options}
        />
      )}
    </Conditionals>
  ) : (
    <TableField
      informationText={prompts}
      name={props.linkId}
      supportingLink={
        supportLinks.length !== 0
          ? () => openSupportingLinks(supportLinks)
          : undefined
      }
      validate={QuestionnaireItemValidator(props)}
      {...rest}
      options={options}
    />
  );
};

export default TableQuestionnaireItem;
